import { gql } from 'graphql-request'
import { fragmentMaskShapeQuery } from '../fragments/mask-shape'
import { fragmentMediaQuery } from '../fragments/media'

export const SingleProgrammeTypeQuery = gql`
  query SingleProgrammeType(
    $slug: String!,
    $isPreview: Boolean! = false,
    $statuses: [ProgrammeType__status_Input] = [published],
    $locale: LocaleInputType!
  ) {
    ProgrammeTypes(
      draft: $isPreview,
      locale: $locale,
      where: {
        AND: [
          { slug: { equals: $slug } }
          { _status: { in: $statuses } }
        ]
      }
    ) {
      docs {
        id
        title
        slug
        type
        programmes {
          docs {
            id
            title
            slug
            recurrences {
              id
              dateTimeStart
              dateTimeEnd
            }
          }
        }
        content {
          ... on Intro {
            id
            blockType
            blockName
            title
            description
            useMask
            image ${fragmentMediaQuery}
            maskedMedia {
              maskShape ${fragmentMaskShapeQuery}
              file ${fragmentMediaQuery}
            }
          }
          ... on Archive {
            id
            blockType
            blockName
            title
            description
            useMask
            image ${fragmentMediaQuery}
            maskedMedia {
              maskShape ${fragmentMaskShapeQuery}
              file ${fragmentMediaQuery}
            }
            archiveViewOption: viewOption
            sortOption
          }
          ... on CurrentAndUpcoming {
            id
            blockType
            blockName
            title
            description
            useMask
            currentAndUpcomingViewOption: viewOption
            image ${fragmentMediaQuery}
            maskedMedia {
              maskShape ${fragmentMaskShapeQuery}
              file ${fragmentMediaQuery}
            }
          }
        }
      }
      totalDocs
    }
  }
`
